
export const paymentOriginURLKey = 'origin_url';
export const paymentAmountURLKey = 'amount';
export const paymentDescriptionURLKey = 'description';
export const paymentReservationURLKey = 'reservation';
export const paymentROITypeURLKey = 'type';
export const paymentROISubTypeURLKey = 'sub_type';
export const paymentRedirectStatus = 'redirect_status';
export const paymentCallbackError = 'callback_error';